import type { AddressDto } from '@dhl/mdp-api'
import type { Address } from '~/common/components/addresses'

export const convertToAddress = (addressDto: AddressDto | undefined): Address => {
  const {
    number = '',
    zipCode = '',
    addition = '',
    countryCode = '',
    street = '',
    additionalAddressLine = '',
    additionalInfo = '',
    city = '',
    isBusiness = true,
  } = addressDto || {}
  return {
    isBusiness,
    street,
    houseNumber: number,
    houseNumberSuffix: addition,
    postalCode: zipCode,
    city,
    countryCode,
    additionalAddressLine,
    additionalInfo,
  }
}
